import * as React from 'react';
import { ReactNode, useMemo } from 'react';
import { UserRole } from 'src/store/users/user';
import { useAuth } from './AuthContext';

interface Props {
  role: UserRole;
  children: ReactNode;
  unauthorized?: () => ReactNode;
}

export const Authorization: React.FC<Props> = ({
  role,
  children,
  unauthorized
}) => {
  const { user } = useAuth();

  const hasAccess = useMemo(() => {
    return user?.roles.some((r: string) => r === role);
  }, [user, role]);

  if (hasAccess) {
    return <>{children}</>;
  }
  return <>{unauthorized ? unauthorized() : null}</>;
};
